<script>
import { groceryComputed, groceryMethods } from '@state/helpers';

export default {
  name: 'GroceryListDetail',
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    },
  },
  data() {
    return {
      inputs: [],
    };
  },
  computed: {
    ...groceryComputed,
    selectedItem() {
      return this.data;
    },
  },
  mounted() {},
  methods: {
    ...groceryMethods,
    addItemInput() {
      const length = this.inputs.length;
      if (length && !this.inputs[length - 1].name) {
        return;
      }
      this.inputs.push({ name: '' });
    },
    closeItem() {
      this.setSelectedItem(null);
    },
    async onDeleteItem(item) {
      await this.deleteGroceryListItem(item.ingredientItemIds);
      this.setDeleteGroceryItem(item);
    },
    async onEnter(value) {
      const newItem = {
        count: value.count,
        name: value.name,
        categoryId: this.selectedItem.id,
      };

      const res = await this.addGroceryListItem(newItem);
      this.setNewGroceryItem({ categoryId: this.selectedItem.id, res });
      this.inputs = [];
    },
  },
};
</script>

<template>
  <div class="grocery-list-detail">
    <div class="grocery-list-staples" v-if="selectedItem.stapleItems.length">
      <h3>Staples</h3>
      <p>Need to stock up? These items are in your plan. Add them to your list.</p>
      <div class="staple-item" v-for="(staple, i) in selectedItem.stapleItems" :key="i">
        <div class="item-title">
          {{ staple.name || staple.ingredient.name }}
        </div>
        <BaseButton type="button" class="btn-clear secondary">
          Clear
        </BaseButton>
        <BaseButton type="button" class="btn-clear">
          Add
        </BaseButton>
      </div>
    </div>

    <div class="additional-items-wrapper">
      <BaseGroceryListItem
        ref="swipeableItem"
        v-for="item in selectedItem.groceryItems"
        :key="item.id"
        :item="item"
        :isDeletable="true"
        :isSelectable="true"
        @delete-item="onDeleteItem"
      />
      <div class="input-wrapper" v-for="(input, i) in inputs" :key="i">
        <BaseInputText inputType="text" v-model="input.name" :showIcon="false" placeholder="Name" @keyup.enter="onEnter(input)" />
        <BaseInputText inputType="text" v-model="input.count" placeholder="1 oz" @keyup.enter="onEnter(input)" />
      </div>
      <div class="add-item-wrapper">
        <BaseButton type="button" class="btn-primary btn-round btn-ghost" @click="addItemInput">
          Add New Item
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.grocery-list-detail {
  position: relative;

  .additional-items-wrapper {
    height: 100vh;
    margin-bottom: 0;
    padding-bottom: 20rem;
  }

  .grocery-list-staples {
    background-color: $color-grocery-list-staples-bg;
    padding: 2rem 1rem;

    p {
      color: $color-grocery-list-staples-text;
      font-size: 1.5rem;
      font-style: italic;
      line-height: 1.2;
      margin-bottom: 1.6rem;
    }
  }

  .staple-item {
    align-items: center;
    background-color: $color-grocery-list-item-bg;
    border: 1px solid $color-grocery-list-item-border;
    border-radius: $base-border-radius;
    display: flex;
    height: 7rem;
    margin-bottom: 0.5rem;
    padding: 1.25em 1em 1.25em 1em;

    &:hover,
    &:active {
      box-shadow: $color-grocery-list-item-shadow;
      cursor: pointer;
    }

    .item-icon {
      flex: 1;

      img {
        width: 60%;
      }
    }

    .item-title {
      color: $color-grocery-list-item-text;
      flex: 3;
      font-size: 1.7rem;
      font-weight: 600;
      line-height: 1;
    }

    .btn-clear {
      color: $color-action;
      font-weight: 400;
      text-transform: capitalize;

      &.secondary {
        color: $color-grocery-list-item-text-alt !important;
      }
    }

    button {
      margin-top: 0;
    }
  }

  .additional-items-wrapper {
    margin-bottom: 10rem;
    overflow-y: scroll;
    padding: 1rem;

    .input-wrapper {
      display: flex;
      position: relative;

      div:first-of-type {
        flex: 2;
      }
    }

    .add-item-wrapper {
      display: flex;
      justify-content: center;
      margin-top: 2rem;
    }
  }
}
</style>
